import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import { PasswordReset } from '@imprivata/nucleus';
import headerImage from '../../images/lock.svg';
import LogoutStyled from '../shared/LogoutStyled';


/**
 * PasswordResetPage Component
 */
export class PasswordResetPage extends Component {
  state = {
    password: '',
    passwordConfirm: '',
  };
  /**
   * The allowed properties for the PasswordResetPage component
   * @param {function} changePassword change the enrolled password to the given password
   * @param {array} errorCode the error codes to be displayed
   */
  static propTypes = {
    changePassword: PropTypes.func.isRequired,
    errorCode: PropTypes.array,
  };

  submit = state => {
    this.props.changePassword(state.password);
    this.setState({ password: '', passwordConfirm: '', });
  };

  handleInputChange = data => {
    this.setState({
      password: data.password,
      passwordConfirm: data.passwordConfirm,
    });
  };

  render() {
    const { password, passwordConfirm, } = this.state;
    const { errorMessage, } = this.props;

    return (
      <div className='content-body'>
        <PasswordReset
          headerImage={headerImage}
          headerTitle='Reset password'
          onInputChange={data => this.handleInputChange(data)}
          submitText='Save password'
          onSubmit={this.submit}
          autoFocus={true}
          displayErrors={errorMessage}
          validation={{ passwordConfirm: { presence: true, equality: 'password', }, }}
          passwordValue={password}
          passwordConfirmValue={passwordConfirm}
          logoutComponent={<LogoutStyled type='white' />}
        />
      </div>
    );
  }
}


const mapStateToProps = state => {
  const { errorCode, errorMessage, } = state.login;
  return { errorCode, errorMessage, };
};

const mapDispatchToProps = dispatch => {
  return {
    changePassword: password => {
      dispatch(actions.changePassword(password) );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetPage);
